export default function initCommunity(root = document) {
  const scope = root instanceof Element ? root : document;

  scope.querySelectorAll('.community-dev').forEach((page) => {
    if (page.dataset.communityReady === 'true') return;

    const rail = page.querySelector('.community-dev__benefits-grid');
    const previous = page.querySelector('[data-community-benefits-prev]');
    const next = page.querySelector('[data-community-benefits-next]');
    const firstCard = rail?.querySelector('.community-dev__benefit-card');

    if (!rail || !previous || !next || !firstCard) return;

    const step = () => {
      const gap = Number.parseFloat(getComputedStyle(rail).columnGap) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

    previous.addEventListener('click', () => rail.scrollBy({left: -step(), behavior: 'smooth'}));
    next.addEventListener('click', () => rail.scrollBy({left: step(), behavior: 'smooth'}));
    page.dataset.communityReady = 'true';
  });
}
